import type { InternalTableSchema } from './types';
import { normalizeSchema } from './normalizer';

/**
 * Module-level fallback schema.
 * Used when normalization throws so internalSchema is always a valid object.
 * All downstream hooks can safely access internalSchema.features, .columns etc.
 */
export const EMPTY_SCHEMA: InternalTableSchema = normalizeSchema({ columns: [] });
